
import {mapState} from "vuex"
import qs from "qs";
import PageItem from "./phone/PageItem";
import addImages from "@/components/h5/addImages";
import cloneDeep from "lodash/cloneDeep";
import html2canvas from "html2canvas";
import {dataURLtoFile} from "../utils/switchingMode";
import {Toast} from "vant";

export default {
  name: "Phone",
  components: {PageItem, addImages},
  data() {
    return {
      x: 0,
      y: 0,
      zoom: 1,
      realIndex: 0,
      active: 0,
      imgs: [],
      videos: [],
      fonts: [],
      activeId: "",
      imgList: false,
      videoList: false,
      index: 0,
      getIndex: null,
      type: "img",
      show: false,
      musics: [],
      prmgremMsg: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    transitionEnd() {
      this.$nextTick(() => {
        const realIndex = this.$refs['swiperOption'].$swiper ? this.$refs['swiperOption'].$swiper.realIndex : 0
        if (realIndex === this.realIndex) {
          return
        }
        this.realIndex = realIndex
      })
    },
    // 获取场景列表
    async getSceneList() {
      await this.$ajax.post("/etv/selectProgramMouldSceneInfo.json", qs.stringify({pmId: this.$route.params.id})).then(res => {
        if (res.data.code === 0) {
          this.$store.state.width = parseInt(res.data.data[0].resolution.split("*")[0])
          this.$store.state.height = parseInt(res.data.data[0].resolution.split("*")[1])
          this.$store.state.scId = res.data.data[0].scId
          this.prmgremMsg = res.data.data
        }
      })
    },
    // 获取场景
    async getSceneData(parame, scId) {
      await this.$ajax.post("/etv/selectSceneInfo.json", qs.stringify({
        pmId: this.$route.params.id,
        scId: scId
      })).then(res => {
        if (res.data.code === 0) {
          this.$store.state.previewPages = JSON.parse(res.data.data.componentsList[0].txList[0].taAddress)
          this.imgs = []
          this.videos = []
          this.fonts = []
          this.previewPages.pageList[this.realIndex].node.map(res => {
            if (res.type === 'img') {
              this.imgs.push(res)
            } else if (res.type === 'video') {
              this.videos.push(res)
            } else {
              this.fonts.push(res)
            }
          })
        }
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    async init() {
      await this.getSceneList(this.$route.params)
      await this.getSceneData(this.$route.params, this.scId)
      this.$nextTick(() => {
        const phoneWidth = this.$refs['pageContent'].clientWidth
        const phoneHeight = this.$refs['pageContent'].clientHeight

        if (phoneWidth / phoneHeight < this.width / this.height) {
          this.zoom = phoneWidth / this.width
        } else {
          this.zoom = phoneHeight / this.height
        }

        const w = document.getElementById('h5-arrow').clientWidth * this.zoom
        const h = document.getElementById('h5-arrow').clientHeight * this.zoom


        if (phoneWidth / phoneHeight < this.width / this.height) {
          this.x = 0
          this.y = (phoneHeight - h) / 2
        } else {
          this.x = (phoneWidth - w) / 2
          this.y = 0
        }


      })
    },
    onLeft() {
      this.realIndex--
      if (this.realIndex === 0) {
        this.realIndex = 0
      }
    },
    close() {
      this.imgList = false
    },
    onRight() {
      this.realIndex++
      if (this.realIndex === this.previewPages.pageList.length - 1) {
        this.realIndex = this.previewPages.pageList.length - 1
      }
    },
    setActiveId(activeId, index) {
      this.index = index
      this.activeId = activeId
    },
    onReplace(type) {
      this.type = type
      this.imgList = true
    },
    setImages(data) {
      this.imgList = false
      if (this.type === 'img') {
        this.imgs.splice(this.index, 1, data[0])
        this.previewPages.pageList[this.realIndex].node.forEach((res, index) => {
          if (res.id === this.activeId) {
            this.getIndex = index
          }
        })
        this.previewPages.pageList[this.realIndex].node[this.getIndex].url = this.upFileUrl + data[0].url
        this.$set(this.previewPages.pageList[this.realIndex].node, this.getIndex, this.previewPages.pageList[this.realIndex].node[this.getIndex])
      } else if (this.type === 'bg') {
        this.previewPages.pageList[this.realIndex].pageBg = this.upFileUrl + data[0].url
      }
    },
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,
      })
    },
    async saveNodePage(callback) {
      this.$store.state.isSave = true
      const copyPages = cloneDeep(this.previewPages)
      copyPages.pageList.forEach(item => {
        item.node.forEach(res => {
          res.infoHeight = res.infoHeightDr
          res.infoWidth = res.infoWidthDr
          res.infoLeft = res.infoLeftDr
          res.infoTop = res.infoTopDr
        })
      })
      let form = new FormData()
      let obj = {}

      obj.pmId = this.$route.params.id
      obj.backImg = ""
      obj.backImgId = ""
      obj.backImgSize = ""
      obj.scTime = "0"
      obj.sort = 1
      obj.scId = this.scId
      obj.scName = "test"
      obj.type = "4"
      obj.html = "hello word"
      obj.isSaveBtn = true
      obj.compents = [
        {
          "type": "webPage",
          "leftPosition": 0,
          "rightPosition": 0,
          "width": this.width,
          "height": this.height,
          "actionType": 1,
          "linkAction": 1,
          "screenProtectTime": "10",
          "materials": [{
            "color": "#fff", // 颜色
            "content": `http://192.168.1.56:8080/web/#/previewh5/${this.$route.params.id.id}`, // 内容
            "fontSize": "36", // 长度
            "move": '1', // 滚动方向
            "no": 1, // 序号
            "alignment": 1, // 对齐方式
            "bgColor": "#fff", // 字幕背景色
            "moveSpeed": 1, // 字幕滚动速度
            "difference": 2, // 属性控件 字幕、天气、日期等控件
            "address": JSON.stringify(copyPages), // 地址
            "countDown": "res.taCountDown"
          }],
        }
      ]

      await html2canvas(this.$refs.previewPages, {
        backgroundColor: null     // 解决生成的图片有白边
      }).then((canvas) => {
        let jietu = canvas.toDataURL("image/jpeg")
        const result = dataURLtoFile(jietu, 'test.jpeg')
        form.append("scenenJsonStr", JSON.stringify(obj))
        form.append("files", result)
      }).catch(err => {
        console.error(err)
      })

      await this.$ajax({
        url: "/etv/insertSceneInfo.json",
        method: 'post',
        header: {
          'Content-Type': 'multipart/form-data'
        },
        data: form
      }).then(res => {
        this.$store.state.isSave = false
        if (res.data.code === 0) {
          Toast(res.data.msg);
          callback && callback(`/addTask`, {
            grogramIds: this.$route.params.id,
            parentPage: 'taskList',
            progremData: this.prmgremMsg
          })
        }
      })
    },
    getBjMusic() {
      this.$ajax.post("/etv/selectAllAudio.json").then(res => {
        if (res.data.code === 0) {
          this.musics = res.data.data
          this.show = true
        }
      })
    },
    setBjMusics(data) {
      this.previewPages.setting.musicUrl = this.upFileUrl + data.url
      this.previewPages.setting.musicName = data.name
      this.show = false
    },
  },
  watch: {
    realIndex(newVal) {
      this.imgs = []
      this.videos = []
      this.fonts = []
      this.previewPages.pageList[newVal].node.map(res => {
        if (res.type === 'img') {
          this.imgs.push(res)
        } else if (res.type === 'video') {
          this.videos.push(res)
        } else {
          this.fonts.push(res)
        }
      })
    }
  },
  computed: {
    ...mapState({
      pageIndex: state => state.pageIndex,
      scId: state => state.scId,
      previewPages: state => state.previewPages,
      width: state => state.width,
      height: state => state.height,
    }),
  },
}
